import React from 'react';
import { Container } from './Containers';
import { Marketing } from './Marketing';
import { FullWidthImage } from './FullWidthImage';
import { Heading } from './Heading';
import { Html } from './Html';
import { tablet, minWidth } from '../screenSizes';
import { largeMargin } from '../margins';

export const Section = ({
  heading,
  content,
  image,
  className,
  marketing,
  scrollToRef,
}) => [
  <div
    key="full-width-image"
    css={`
      position: relative;
    `}
  >
    <FullWidthImage
      css={`
        margin-bottom: ${largeMargin};
      `}
      image={image}
    />
    {marketing && <Marketing {...marketing} />}
  </div>,
  <Container
    key="section"
    css={`
      ${className};
    `}
  >
    <Heading innerRef={scrollToRef}>{heading}</Heading>
    {content &&
      content.trim().length && (
        <Html
          css={`
            ${minWidth(tablet)} {
              width: 60%;
            }
          `}
          html={content}
        />
      )}
  </Container>,
];



// WEBPACK FOOTER //
// ./app/components/Section.js